// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdjustCoverTitleFontController from "./adjust_cover_title_font_controller"
application.register("adjust-cover-title-font", AdjustCoverTitleFontController)

import AdjustFontController from "./adjust_font_controller"
application.register("adjust-font", AdjustFontController)

import AudioRecorderController from "./audio_recorder_controller"
application.register("audio-recorder", AudioRecorderController)

import AutoOpenVideoController from "./auto_open_video_controller"
application.register("auto-open-video", AutoOpenVideoController)

import AutoOpenVoiceMessageController from "./auto_open_voice_message_controller"
application.register("auto-open-voice-message", AutoOpenVoiceMessageController)

import AvatarSliderController from "./avatar_slider_controller"
application.register("avatar-slider", AvatarSliderController)

import BatchImportController from "./batch_import_controller"
application.register("batch-import", BatchImportController)

import BlankPagesFormController from "./blank_pages_form_controller"
application.register("blank-pages-form", BlankPagesFormController)

import BlankPagesToggleController from "./blank_pages_toggle_controller"
application.register("blank-pages-toggle", BlankPagesToggleController)

import BookEditorController from "./book_editor_controller"
application.register("book-editor", BookEditorController)

import BookForSyncController from "./book_for_sync_controller"
application.register("book-for-sync", BookForSyncController)

import BookSliderController from "./book_slider_controller"
application.register("book-slider", BookSliderController)

import BookStyleSelectionController from "./book_style_selection_controller"
application.register("book-style-selection", BookStyleSelectionController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import ColorsPickerBookController from "./colors_picker_book_controller"
application.register("colors-picker-book", ColorsPickerBookController)

import ColorsPickerInviteController from "./colors_picker_invite_controller"
application.register("colors-picker-invite", ColorsPickerInviteController)

import ColorsPickerOrgController from "./colors_picker_org_controller"
application.register("colors-picker-org", ColorsPickerOrgController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DragAndDropController from "./drag_and_drop_controller"
application.register("drag-and-drop", DragAndDropController)

import EmailInputController from "./email_input_controller"
application.register("email-input", EmailInputController)

import FinishDateController from "./finish_date_controller"
application.register("finish-date", FinishDateController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import FullSizeContentController from "./full_size_content_controller"
application.register("full-size-content", FullSizeContentController)

import FullSizeContentUploadController from "./full_size_content_upload_controller"
application.register("full-size-content-upload", FullSizeContentUploadController)

import FrontCoverToggleController from "./front_cover_toggle_controller"
application.register("front-cover-toggle", FrontCoverToggleController)

import FrontCoverUploadController from "./front_cover_upload_controller"
application.register("front-cover-upload", FrontCoverUploadController)

import HideAvatarController from "./hide_avatar_controller"
application.register("hide-avatar", HideAvatarController)

import HideDesignAvatarController from "./hide_design_avatar_controller"
application.register("hide-design-avatar", HideDesignAvatarController)

import HideContactSectionController from "./hide_contact_section_controller"
application.register("hide-contact-section", HideContactSectionController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InviteShufflerController from "./invite_shuffler_controller"
application.register("invite-shuffler", InviteShufflerController)

import LanguageSelectController from "./language_select_controller"
application.register("language-select", LanguageSelectController)

import LayoutSwitcherController from "./layout_switcher_controller"
application.register("layout-switcher", LayoutSwitcherController)

import LogoController from "./logo_controller"
application.register("logo", LogoController)

import LogoUploadController from "./logo_upload_controller"
application.register("logo-upload", LogoUploadController)

import MiscHelperController from "./misc_helper_controller"
application.register("misc-helper", MiscHelperController)

import MultiPhotosController from "./multi_photos_controller"
application.register("multi-photos", MultiPhotosController)

import MyavatarController from "./myavatar_controller"
application.register("myavatar", MyavatarController)

import MobileQuestionModalController from "./mobile_question_modal_controller"
application.register("mobile-question-modal", MobileQuestionModalController)

import OrganizationLogoController from "./organization_logo_controller"
application.register("organization-logo", OrganizationLogoController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PersonalPhotoController from "./personal_photo_controller"
application.register("personal-photo", PersonalPhotoController)

import PersonalUploadController from "./personal_upload_controller"
application.register("personal-upload", PersonalUploadController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PictureRotateController from "./picture_rotate_controller"
application.register("picture-rotate", PictureRotateController)

import PreventEmojiInputController from "./prevent_emoji_input_controller"
application.register("prevent-emoji-input", PreventEmojiInputController)

import PreventLineBreaksController from "./prevent_line_breaks_controller"
application.register("prevent-line-breaks", PreventLineBreaksController)

import ProfilePhotoController from "./profile_photo_controller"
application.register("profile-photo", ProfilePhotoController)

import ParticipantSubmitController from "./participant_submit_controller"
application.register("participant-submit", ParticipantSubmitController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import RemovalConfirmationModalController from "./removal_confirmation_modal_controller"
application.register("removal-confirmation-modal", RemovalConfirmationModalController)

import ThemeSelectionController from "./theme_selection_controller"
application.register("theme-selection", ThemeSelectionController)

import ToggleShippingController from "./toggle_shipping_controller"
application.register("toggle-shipping", ToggleShippingController)

import ToggleSinglePageInviteController from "./toggle_single_page_invite_controller"
application.register("toggle-single-page-invite", ToggleSinglePageInviteController)

import TransferBookController from "./transfer_book_controller"
application.register("transfer-book", TransferBookController)

import TurboFormController from "./turbo_form_controller"
application.register("turbo-form", TurboFormController)

import VotingChoicesController from "./voting_choices_controller"
application.register("voting-choices", VotingChoicesController)

import PresentationModeController from "./presentation_mode_controller"
application.register("presentation-mode", PresentationModeController)

import PieVotingController from "./pie_voting_controller"
application.register("pie-voting", PieVotingController)

import ParticipantVotingController from "./participant_voting_controller"
application.register("participant-voting", ParticipantVotingController)

import ParticipantPieVotingController from "./participant_pie_voting_controller"
application.register("participant-pie-voting", ParticipantPieVotingController)

import StatementInputController from "./statement_input_controller"
application.register("statement-input", StatementInputController)

import StatementVotingController from "./statement_voting_controller"
application.register("statement-voting", StatementVotingController)

import SaveBeforeNavigateController from "./save_before_navigate_controller"
application.register("save-before-navigate", SaveBeforeNavigateController)
